import { createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6e75b087"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "h-100" }
const _hoisted_2 = {
  class: "display-flex margin-top",
  style: {"height":"calc(100% - 200px)"}
}
const _hoisted_3 = { class: "news-table-div" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "m-0 p-0 news-table-title" }, "Back Number", -1 /* HOISTED */))
const _hoisted_5 = { class: "scroll-table news_table" }
const _hoisted_6 = {
  class: "table m-0",
  rules: "groups"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "width-10" }, "■", -1 /* HOISTED */))
const _hoisted_8 = { class: "subject_td" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { key: 0 }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  class: "text-center",
  style: {"font-style":"italic"}
}, "No data.", -1 /* HOISTED */))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { style: {"float":"right","margin-top":"5px"} }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-caret-left-fill" }),
  /*#__PURE__*/_createTextVNode("Back")
], -1 /* HOISTED */))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = {
  class: "modal fade",
  id: "showModal",
  tabindex: "-1",
  "aria-labelledby": "showModalLabel",
  "aria-hidden": "true"
}
const _hoisted_17 = { class: "modal-dialog modal-dialog-scrollable modal-lg" }
const _hoisted_18 = { class: "modal-content" }
const _hoisted_19 = { class: "modal-header" }
const _hoisted_20 = {
  class: "modal-title",
  id: "showModalLabel"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1 /* HOISTED */))
const _hoisted_22 = {
  class: "modal-body",
  id: "modal-body",
  style: {"text-align":"left"}
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-footer" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn btn-secondary",
    "data-bs-dismiss": "modal"
  }, " Close ")
], -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["Loading"], { isLoading: $setup.isLoading }, null, 8 /* PROPS */, ["isLoading"]),
    _createVNode($setup["Navigation"]),
    _createVNode($setup["Alert"], {
      alertMessage: $setup.alertMessage,
      alertState: $setup.alertState
    }, null, 8 /* PROPS */, ["alertMessage", "alertState"]),
    _createElementVNode("div", _hoisted_2, [
      _createCommentVNode(" News Table Start "),
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("table", _hoisted_6, [
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.newsInfo, (info, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  _hoisted_7,
                  _createElementVNode("td", {
                    class: "news_date_td",
                    style: _normalizeStyle({ color: info.importance.color })
                  }, _toDisplayString(info.startDate), 5 /* TEXT, STYLE */),
                  _createElementVNode("td", _hoisted_8, [
                    _createElementVNode("a", {
                      href: "#",
                      "data-bs-toggle": "modal",
                      "data-bs-target": "#showModal",
                      onClick: ($event: any) => ($setup.modalShow(index)),
                      style: _normalizeStyle({ color: info.importance.color })
                    }, _toDisplayString(info.Subject), 13 /* TEXT, STYLE, PROPS */, _hoisted_9)
                  ])
                ]))
              }), 128 /* KEYED_FRAGMENT */)),
              ($setup.newsInfo.length == 0 && $setup.getData)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_10, _hoisted_12))
                : _createCommentVNode("v-if", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-secondary button-margin button-width",
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.linkBack()))
          }, _hoisted_15)
        ])
      ]),
      _createCommentVNode(" News Table End ")
    ]),
    _createCommentVNode(" Modal "),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("h5", _hoisted_20, _toDisplayString($setup.modalSubject[0]), 1 /* TEXT */),
            _hoisted_21
          ]),
          _createElementVNode("div", _hoisted_22, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.modalBody, (info, index) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                _createTextVNode(_toDisplayString(info) + " ", 1 /* TEXT */),
                _hoisted_23
              ], 64 /* STABLE_FRAGMENT */))
            }), 128 /* KEYED_FRAGMENT */))
          ]),
          _hoisted_24
        ])
      ])
    ])
  ]))
}